import React, { useState } from "react";
import Latex from "react-latex-next";
import "katex/dist/katex.min.css";
import LatexInput from "./LatexInput"; // ✅ still used for final answer only

const sampleQuestion = {
  subject: "GCSE Maths",
  topic: "Linear Equations",
  type: "short-answer",
  question: "Solve for \\( x \\): \\[ 2x + 3 = 7 \\]",
  answer: "2",
};

function QuestionCardTest() {
  const [working, setWorking] = useState("");
  const [answer, setAnswer] = useState("");

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        {/* Header */}
        <div style={styles.header}>
          <span style={styles.subject}>{sampleQuestion.subject}</span>
          <span style={styles.topic}>{sampleQuestion.topic}</span>
          <span style={styles.difficulty}>● Student View</span>
        </div>

        {/* Question */}
        <h2 style={styles.questionText}>
          <Latex>{sampleQuestion.question}</Latex>
        </h2>

        {/* Final Answer */}
        <label style={styles.label}>✅ Final Answer:</label>
        <LatexInput value={answer} onChange={setAnswer} />

        {/* Working */}
        <label style={{ ...styles.label, marginTop: "1.5rem" }}>
          🧠 Show your working:
        </label>
        <textarea
          value={working}
          onChange={(e) => setWorking(e.target.value)}
          placeholder="Explain each step clearly..."
          style={styles.workingBox}
        />

        {/* Buttons */}
        <div style={styles.actions}>
          <button style={styles.previewBtn}>👁️ Preview</button>
          <button style={styles.addBtn}>📨 Submit</button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    minHeight: "100vh",
    background: "#e3efff",
    padding: "2rem",
    fontFamily: "Poppins, sans-serif",
  },
  card: {
    maxWidth: "700px",
    background: "white",
    margin: "auto",
    padding: "2rem",
    borderRadius: "12px",
    boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
  },
  header: {
    display: "flex",
    gap: "1rem",
    marginBottom: "1rem",
    fontSize: "0.9rem",
    color: "#555",
  },
  subject: {
    background: "#e0e7ff",
    padding: "0.2rem 0.6rem",
    borderRadius: "6px",
  },
  topic: {
    background: "#ffe0f0",
    padding: "0.2rem 0.6rem",
    borderRadius: "6px",
  },
  difficulty: {
    background: "#fff3c4",
    padding: "0.2rem 0.6rem",
    borderRadius: "6px",
  },
  questionText: {
    fontSize: "1.2rem",
    marginBottom: "1.5rem",
    color: "#222",
  },
  label: {
    fontWeight: "600",
    marginBottom: "0.5rem",
    display: "block",
    color: "#333",
  },
  workingBox: {
    width: "100%",
    minHeight: "150px",
    padding: "0.8rem 1rem",
    border: "1px solid #ccc",
    borderRadius: "8px",
    fontSize: "1rem",
    fontFamily: "Poppins, sans-serif",
    backgroundColor: "#f9f9f9",
    resize: "vertical",
    lineHeight: "1.5",
    marginBottom: "1.5rem",
  },
  actions: {
    display: "flex",
    gap: "1rem",
    justifyContent: "flex-end",
    marginTop: "2rem",
  },
  previewBtn: {
    backgroundColor: "#6c63ff",
    color: "white",
    border: "none",
    padding: "0.6rem 1.2rem",
    borderRadius: "8px",
    cursor: "pointer",
  },
  addBtn: {
    backgroundColor: "#27ae60",
    color: "white",
    border: "none",
    padding: "0.6rem 1.2rem",
    borderRadius: "8px",
    cursor: "pointer",
  },
};

export default QuestionCardTest;
